export const devicelistMenuRouter = [{
  path: 'device/list',
  icon: ' iconfont icondevice',
  name: 'deviceList',
  title: '设备管理',
  component: () => import('@/views/gip/device/list.vue')
}]



// WEBPACK FOOTER //
// ./src/router/device/devicelist.js